export class DocumentDate {
  reportedDate: string = null;
  statementDate?: string = null;
  balanceStatementDate: string = null;
  incomeStatementDate: string = null;
  cashFlowStatementDate: string = null;
}
